export default __webpack_public_path__ + "static/media/code.9f5ede04.svg";